const experiences = [
  {
    id: 1,
    name: "Siri",
    company: "Google",
    role: "Software Engineer",
    assessment: "Focused mainly on DSA problems from arrays, graphs, and strings.",
    resumeTips: "Showcase strong problem-solving projects and mention your coding profiles (LeetCode, Codeforces, etc.).",
    interview: "4 rounds — 2 DSA rounds, 1 System Design, 1 HR round.",
    description:
      "Google’s rounds were challenging but logical. Focus on clarity of thought while coding. I practiced 1–2 problems daily for consistency. Resume should reflect your coding journey and not just tools you’ve used."
  },
  {
    id: 2,
    name: "Bindu Reddy",
    company: "Microsoft",
    role: "Frontend Developer",
    assessment: "JavaScript-based coding round followed by UI design discussion.",
    resumeTips: "Highlight live web apps and add GitHub/portfolio links.",
    interview: "3 rounds — Technical, UI/UX deep dive, HR.",
    description:
      "Microsoft emphasized user experience. I showcased 2 personal projects with React and explained UI decisions. HR round focused on teamwork and problem ownership. Be ready to discuss your design logic, not just code."
  },
  {
    id: 3,
    name: "Afsiya Naaz",
    company: "Amazon",
    role: "SDE 1 (Intern to FTE)",
    assessment: "Online assessment on arrays, trees, and string manipulation.",
    resumeTips: "Keep your resume one page with measurable outcomes (like ‘reduced API latency by 30%’).",
    interview: "3 technical rounds (coding + system design) and one behavioral.",
    description:
      "Amazon values clarity and structured answers (STAR method). Keep your explanations concise and practice system design basics. Also, learn to discuss trade-offs in solutions."
  },
  {
    id: 4,
    name: "Ritika",
    company: "Deloitte",
    role: "Data Analyst",
    assessment: "Aptitude + SQL + basic Excel automation questions.",
    resumeTips: "Add certifications like Power BI, SQL, or Excel to strengthen your data profile.",
    interview: "2 rounds — Technical and HR.",
    description:
      "Deloitte focuses on communication and analytical thinking. Revise Excel formulas and SQL joins. HR checks confidence and clarity. Avoid writing too many generic skills on your resume — keep it crisp and role-relevant."
  },
  {
    id: 5,
    name: "Meghana",
    company: "TCS",
    role: "Software Trainee",
    assessment: "Aptitude, logical reasoning, and 1 basic coding round.",
    resumeTips: "Keep it simple — include internships, workshops, and tech events.",
    interview: "1 technical + 1 HR round.",
    description:
      "TCS looks for consistency and confidence. Prepare basics of OOPs, DBMS, and OS. In HR, communicate clearly and stay calm. Avoid memorized answers — be genuine."
  },
  {
    id: 6,
    name: "Ananya",
    company: "Accenture",
    role: "Application Development Associate",
    assessment: "Cognitive + technical MCQs (SQL, OOPs) and a coding task.",
    resumeTips: "Avoid spelling errors — have a senior proofread it. Mention real contributions to projects.",
    interview: "Technical + HR round.",
    description:
      "Accenture checks communication and basic logic. Practice mock interviews with friends. Confidence and structured answers help more than complex code."
  },
  {
    id: 7,
    name: "Shravya",
    company: "Adobe",
    role: "UI/UX Engineer",
    assessment: "Portfolio-based shortlisting + design logic interview.",
    resumeTips: "Attach a strong portfolio — show before/after designs and usability tests.",
    interview: "2 design-focused + 1 HR round.",
    description:
      "Adobe appreciated storytelling around my projects — explaining design problems and user feedback loops. Avoid flashy resumes — minimal and clean layout works best."
  },
  {
    id: 8,
    name: "Priyanka",
    company: "Infosys",
    role: "System Engineer",
    assessment: "Aptitude, verbal, and simple programming questions (loops, arrays).",
    resumeTips: "Include hackathons or any open-source work.",
    interview: "Technical + HR round.",
    description:
      "Infosys prefers candidates with consistent academic performance. Focus on fundamentals and confidence. Don’t overexplain — keep answers short and relevant."
  }
];

export default experiences;
